import script from "./RouteStatsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteStatsTable.vue?vue&type=script&setup=true&lang=js"

import "./RouteStatsTable.vue?vue&type=style&index=0&id=2bf97298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf97298"]])

export default __exports__